import { whiteColor } from '../global';

const FAQPageStyle = (theme) => ({
    wrapper: {
        backgroundColor: (props) => ((+props?.role !== 1) && props?.customColorQA?.screen_background_color) || whiteColor,
    },
    question: {
        backgroundColor: (props) => ((+props?.role !== 1) && props?.customColorQA?.question_page?.question_line_background_color) || 'rgba(231, 233, 236, 0.5)',
        wordBreak: 'break-word',
        fallbacks: [
            { wordBreak: 'break-all' },
        ],
    },
    answer: {
        backgroundColor: (props) => ((+props?.role !== 1) && props?.customColorQA?.question_page?.answer_line_background_color) || '#EAF9FF',
        wordBreak: 'break-word',
        fallbacks: [
            { wordBreak: 'break-all' },
        ],
    },
    styleDiv: {
        [theme.breakpoints.down('sm')]: {
            display: 'none',
        },
    },
});

export default FAQPageStyle;
